/** Canonical (AWS-style) Secret Manager id of a Tableau site's admin connected
 * app. Other providers rewrite it with their `replacer`. */
export const tableauAiAdminAppSecretId = (siteId: string): string =>
  `p0/install/tableau/${siteId}/admin-app`;

/** Canonical prefix that every session token secret of a Tableau site starts
 * with. Other providers rewrite it with their `replacer`. */
export const tableauAiSessionTokenPrefix = (siteId: string): string =>
  `p0/access-token/tableau/${siteId}/`;

/** The connector's Cloud Run service name. Its Lambda function name adds
 * "-aws". */
export const tableauAiConnectorName = "p0-connector-tableau-ai";
